<template>
  <div class="popup-wraper" @click="onHideModal">
    <div class="popup-overlay" @click.stop>
      <div class="popup-overlay-title">
        <img alt="img" src="@/assets/img/user_settings.svg" />
        <span class="popup-overlay-title-span">Interaction settings</span>
      </div>
      <div class="popup-container">
        <div class="content-wraper">
          <div class="input-wrapper">
            <button @click="showPopoupChangeImage" class="favicon-btn">
              <img alt="img" :src="faviconUrl" @error="setDefaultFavicon" />
            </button>

            <span class="tabs-span">favicon</span>
          </div>
          <div class="input-wrapper">
            <input
              type="text"
              :disabled="editContentMode"
              v-model="interactionName"
            />
            <span class="tabs-span">name/title</span>
          </div>
          <div class="input-wrapper">
            <input type="text" :disabled="editContentMode" v-model="gtagId" />
            <span class="tabs-span">google analytics id</span>
          </div>
          <!-- <div class="input-wrapper">
            <input type="text" v-model="externalDomain" />
            <span class="tabs-span">external domin</span>
          </div> -->
        </div>
        <div class="error">{{ errorMsg }}</div>
        <button
          ref="saveBtn"
          :data-is-avalable="popupsVisible"
          id="apply-btn"
          class="popup-btn"
          @click.prevent="onSave"
        >
          apply
        </button>
      </div>
      <div class="popup-close" @click="onHideModal">&times;</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import "@/assets/css/popups.css";

export default {
  name: "InteractionSettingsPopup",
  components: {},
  data() {
    return {
      externalDomain: "",
      gtagId: "",
      errorMsg: "",
      interactionName: ""
    };
  },
  computed: {
    ...mapGetters({
      popupsVisible: "workSpace/popupsVisible",
      myInteractions: "customContent/myInteractions",
      activeMyInteraction: "workSpace/activeMyInteraction",
      myInteracionFavicon: "workSpace/myInteracionFavicon",
      editContentMode: "workSpace/editContentMode"
    }),
    faviconUrl() {
      return this.myInteracionFavicon || require("@/assets/img/mob-logo.svg");
    }
  },
  mounted() {
    if (this.activeMyInteraction) {
      this.externalDomain = this.activeMyInteraction.external_domain;
      this.gtagId = this.activeMyInteraction.gtag_id;
      this.interactionName = this.activeMyInteraction?.name;
    }
  },
  methods: {
    setDefaultFavicon({ target }) {
      target.src = require("@/assets/img/mob-logo.svg");
    },
    onHideModal() {
      this.$emit("hide-modal");
    },
    showPopoupChangeImage() {
      this.$store.dispatch("workSpace/showPopup", {
        type: "changeImage",
        data: {
          callback: this.onChangeImage,
          idx: null
        }
      });
    },
    onChangeImage(idx, url) {
      this.$store
        .dispatch("customContent/updateMyInteractionFavicon", url)
        .then(() => {
          this.$store.dispatch("workSpace/showPopup", { clearAll: true });
        });
    },
    onSave() {
      this.$store
        .dispatch("customContent/updateInteractionSettings", {
          external_domain: this.externalDomain,
          gtag_id: this.gtagId,
          name: this.interactionName
        })
        .catch(error => {
          this.showErrorMsg(error);
        });
    },
    showErrorMsg(msg = "") {
      this.errorMsg = msg;
    }
  }
};
</script>

<style scoped>
.popup-overlay {
  /* max-width: 1334px;
  max-height: 760px; */
  max-width: 500px;
  max-height: 290px;
  height: auto;
}
.popup-overlay-title {
  margin-bottom: 0;
}
.popup-container {
  display: flex;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 160px);
  /* max-width: 1334px; */
  /* max-height: 600px; */
  max-width: 500px;
  max-height: 600px;
}
.content-wraper {
  margin: 0 7px 7px;
  width: calc(100% - 15px);
  height: calc(100% - 1px);
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
}
.input-wrapper input {
  background: #f8f8f5;
  border: none;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-weight: 600;
  width: 200px;
}
.popup-btn {
  margin: 10px auto 20px;
}
.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin: 20px auto 0;
}
.input-wrapper img {
  width: 100%;
  max-width: 24px;
}
.tabs-span {
  line-height: 1;
  font-size: 12px;
  color: #1d2d36;
  margin-top: 4px;
  font-family: "Montserrat", sans-serif;
}
.favicon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: #fff;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}
.favicon-btn img {
  max-width: 26px;
  max-height: 26 px;
}
.error {
  color: red;
  font-size: 10px;
  font-weight: 600;
}
</style>
